import { RouteTableColumn } from '../route-analysis-report/route-analysis-report.models';

export const ORIGIN_DESTINATION_SUMMARY_COLUMNS: RouteTableColumn[] = [
  { field: 'strPersonnelID', title: 'شماره پرسنلی' },
  { field: 'strFullName', title: 'راننده' },
  { field: 'displayPlate', title: 'پلاک' },
  { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' },
  { field: 'strGeoFence_Origin', title: 'نام محدوده شروع' },
  { field: 'strGeoFence_Destination', title: 'نام محدوده پایان' },
  { field: 'iCount', title: 'تعداد سیر', numeric: true, totalField: 'iCount' },
  { field: 'strTime', title: 'جمع مدت سیر', totalField: 'iTime', totalDuration: true },
  { field: 'fNavigation', title: 'جمع پیمایش سیر (km)', numeric: true, totalField: 'fNavigation', unit: 'کیلومتر' },
  { field: 'strPresenceSTime', title: 'جمع مدت حضور در محدوده شروع' },
  { field: 'strPresenceDTime', title: 'جمع مدت حضور در محدوده پایان' },
];
